import { configureStore } from "@reduxjs/toolkit";
import localDataSlice, { initialState } from "./slice";

export const store = configureStore({
  reducer: {
    data: localDataSlice,
  },
});
